import axios from "axios";
import {sendPostRequest} from "./axiosFormWrapper";
import type {AdressDaten, KonfiguratorAdresseFromBackend} from "./Adresse";
import {noop} from "./globalUtils";

export interface AdressenpersistanceAjaxConnector {
    get(url):Promise<any>;
    post(url, data, datatype?):Promise<any>;
}

export class AdressenpersistanceJQueryAjaxConnector implements AdressenpersistanceAjaxConnector {
    get(url): Promise<any> {
        return new Promise((resolve, reject)=>{
            $.ajax({
                type: "GET",
                url: url,
                dataType: 'json'
            })
                .fail(reject)
                .done(response=>resolve(response));
        });
    }

    post(url, data, datatype?): Promise<any> {

        return new Promise<any>((resolve, reject)=>{
            let settings = {
                type: "POST",
                url: url,
                data: data,
                dataType: datatype,
                success: (response)=>resolve(response),
                error: reject
            };
            $.ajax(settings);
        })
    }

}


export class AdressenPersistanceAxiosAjaxConnector implements AdressenpersistanceAjaxConnector {
    get(url): Promise<any> {
        return new Promise((resolve, reject)=>{
            axios(url).then(response=>resolve(response.data)).catch(reject)
        });
    }

    post(url, data): Promise<any> {
        return new Promise<any>((resolve, reject)=>{
            sendPostRequest(url, data).then(response=>resolve(response.data)).catch(reject)
        })
    }
}


export class    AdressenPersistance {
    private static connector: AdressenpersistanceAjaxConnector;

    public static setAjaxConnector(connector:AdressenpersistanceAjaxConnector) {
        AdressenPersistance.connector= connector;
    }

    public static loadAdressenIncludingInvisible(callback:(response)=>void) {
        AdressenPersistance.loadAdressen(callback, noop, false);
    }

    public static loadAdressen(callback:(response)=>void, errorCallback:()=>void, onlyVisible=true) {
        AdressenPersistance.connector.get("/konfigurator_php/actionmodul/loadAdressen.php?onlyvisible="+(onlyVisible ? "true" : "false"))
            .then(response=>callback(response)).catch(errorCallback)
    }

    public static deleteAdresse(adressenID:string, callback:()=>void=noop, errorCallback:()=>void=noop) {
        AdressenPersistance.connector.post("/konfigurator_php/sessiondata/deleteAdresse.php", {adresse: adressenID}).then(callback).catch(errorCallback)
    }

    public static saveNewAdresse(adressdaten:AdressDaten, callback:(response, adressDaten:AdressDaten)=>void, errorCallback=noop) {
        AdressenPersistance.connector.post("/konfigurator_php/sessiondata/saveNewAdresse.php", AdressenPersistance.getSaveAdresseDataObject(adressdaten), "json")
            .then(response=>{
                if (response.status === "error") {
                    errorCallback();
                }
                else {
                    callback(response, adressdaten);
                }
            })
    }

    private static getSaveAdresseDataObject(adressdaten:AdressDaten) {
        return {
            name: adressdaten.ansprechpartner,
            vorname:adressdaten.vorname,
            verein: adressdaten.verein,
            strasse: adressdaten.street,
            plz: adressdaten.plz,
            ort: adressdaten.ort,
            telefon: adressdaten.tel,
            land: adressdaten.land,
            ustid: adressdaten.ustid,
            state: adressdaten.state,
            zusatz: adressdaten.zusatz,
            geschlecht: adressdaten.geschlecht,
            isFirma: adressdaten.isFirma,
        }
    }

    static replaceAdresseInCurrentWarenkorb(wkid: number, idToReplace: number, newID: number, callback:()=>void) {
        AdressenPersistance.connector.post("/konfigurator_php/sessiondata/replaceAdressenInCurrentWarenkorb.php", {wkid, idToReplace, newID})
            .then(callback);
    }
}

export class AdressenPersistancePromise {

    public static setAjaxConnector(connector:AdressenpersistanceAjaxConnector) {
        AdressenPersistance.setAjaxConnector(connector);
    }

    public static loadAdressenIncludingInvisible() {
        return AdressenPersistancePromise.loadAdressen(false);


    }

    public static loadAdressen(onlyVisible=true) {
        return new Promise<{adressen:KonfiguratorAdresseFromBackend[]}>((resolve, reject)=>{
            AdressenPersistance.loadAdressen(response=>resolve(response), ()=>reject(), onlyVisible);
        })
    }

    public static deleteAdresse(adressenID:string) {
        return new Promise<void>((resolve, reject)=>{
            AdressenPersistance.deleteAdresse(adressenID, ()=>resolve(), ()=>reject())
        })
    }

    public static saveNewAdresse(adressdaten:AdressDaten) {
        return new Promise<any>((resolve, reject)=>{
            AdressenPersistance.saveNewAdresse(adressdaten, (response)=>resolve(response), ()=>reject())
        })
    }

    static replaceAdresseInCurrentWarenkorb(idToReplace: number, newID: number) {
        return new Promise<void>(resolve=>{
            AdressenPersistance.replaceAdresseInCurrentWarenkorb(idToReplace, newID, ()=>resolve())
        })
    }
}
